export default 'eventsPage';
